/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Pageable } from '../../models/pageable';
import { PagedModelProcessItemResponse } from '../../models/paged-model-process-item-response';

export interface GetProcessItems$Params {
  processId: string;
  pageable: Pageable;
}

export function getProcessItems(http: HttpClient, rootUrl: string, params: GetProcessItems$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedModelProcessItemResponse>> {
  const rb = new RequestBuilder(rootUrl, getProcessItems.PATH, 'get');
  if (params) {
    rb.path('processId', params.processId, {});
    rb.query('pageable', params.pageable, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PagedModelProcessItemResponse>;
    })
  );
}

getProcessItems.PATH = '/process/{processId}/items';
